import {
  ORDER_OBJECT,
  ADD_NEW_SHIPMENT_ORDER,
  SAVE_SHIPMENT_INFO,
  CANCEL_SHIPMENT_INFO,
  ADD_NEW_ITEM,
  UPDATE_ORDER,
  REMOVE_ORDER_OBJECT,
  ORDER_SHOWING
} from '../mutation-types';

import axios from 'axios';
import swal from 'sweetalert2'

const mutations = {
  /**
   * Adiciona o pedido que o usuário clicou em um objeto
   * para que ele seja usado para exibição dos dados do mesmo.
   * considere ele como "em destaque"
   */
  [ORDER_OBJECT](state, data) {
    state.order = data;
  },

  /**
   * Remove o pedido em destaque para que a interação
   * com a barra de filtro seja possível.
   * Caso o objeto de order esteja vazio o menu de filtros será exibido
   * do contrario ficara oculto.
   */
  [REMOVE_ORDER_OBJECT](state, data) {
    state.order = {}
  },

  [ORDER_SHOWING](state, data) {
    state.order = data
  },

  /**
   * Para adiciona uma nova entrega é necessário ocupar um espaço
   * no array de entregas para que seja possivel exibir os campos
   * de preenchimento ao usuário utilizando um loop no template do vue.
   */
  [ADD_NEW_SHIPMENT_ORDER](state, data) {
    state.order.shipments.push(data);
  },

  /**
   * Substitui os dados temporários no array de entregas
   * com os dados que foram salvos na API.
   */
  [SAVE_SHIPMENT_INFO](state, data) {
    state.order.shipments.map(shipment => {
      if (shipment.id == data.id || shipment.id == data.shipID) {
        Object.assign(shipment, data);
      }
    });
  },

  /**
   * Remove os dados temporários do array de entregas
   * para ocultar os campos de preenchimento.
   */
  [CANCEL_SHIPMENT_INFO](state, data) {
    state.order.shipments.pop();
  },

  /**
   * Adiciona um novo item ao pedido após a chamada
   * da API ser concluída.
   */
  [ADD_NEW_ITEM](state, data) {
    state.order.items.push(data)
  },

  /**
   * Subsitui todos os dados do pedido em destaque
   * após o mesmo ser atualizado na API.
   */
  [UPDATE_ORDER](state, data) {
    Object.assign(state.order, data)
  }
};

// Objeto de pedido
const state = {
  order: {},
};

const actions = {
  /**
   * Envia para a API uma nova entrega
   * para o pedido em destaque.
   */
  async saveShipping ({ commit, state }, shippingInfo) {
    const savedShipping = [...state.order.shipments];

    let success;

    await axios.post('/api/orders/shipment', shippingInfo)
      .then(response => {
        let registredShipment = response.data;
        success = true;
        commit('ADD_NEW_SHIPMENT_ORDER', registredShipment);
      })
      .catch(error => {
        success = false;
      });

      return success;
  },

  /**
   * Envia um novo item para a API
   * para que ele seja adicionado ao pedido em destaque.
   */
  addNewItem ({ commit, state }, itemInfo) {
    itemInfo.item.total = itemInfo.item.quantity * itemInfo.item.price
    axios.post('/api/orders/item', itemInfo)
    .then(response => {
      let data = JSON.parse(response.data)
      if (data.hasOwnProperty('sku')) {
        commit('ADD_NEW_ITEM', data)
        swal(
          'Pronto!',
          'O novo item foi adicionado ao pedido com sucesso!',
          'success'
        )
      }
    })
    .catch(error => {
      swal(
        'Ops!!',
        'Algo deu errado, tente novamente em alguns instantes',
        'error'
      )
    })
  },

  /**
   * Envia uma atualização dos dados do pedido
   * para a API para o pedido em destaque.
   */
  updateOrder({ commit, state }, orderInfo) {
    axios.put(`/api/orders/${orderInfo.order_id}`, orderInfo)
    .then(response => {
      commit('UPDATE_ORDER', response.data.Order)
      swal(
        'Pronto!',
        'O pedido foi atualizado com sucesso!',
        'success'
      )
      orderInfo.event.target.removeAttribute('disabled')
    })
    .catch(error => {
      swal(
        'Ops!!',
        'Algo deu errado, tente novamente em alguns instantes',
        'error'
      )
      orderInfo.event.target.removeAttribute('disabled')
    })
  },

  /**
   * Realiza um request de um pedido com os parametros:
   * showLogs=true e showHistory=true
   * para exibir os logs ao usuário.
   */
  showOrderLogs({ commit, state }, orderID) {
    axios.get(`/api/orders/${orderID}/logs?useCache=false`)
    .then(response => {
      commit('UPDATE_ORDER', response.data.Order)
    })
    .catch(error => {
      swal(
        'Ops!!',
        'Algo deu errado, tente novamente em alguns instantes',
        'error'
      )
    })
  },

  /**
   * Para exibir o detalhe de um pedido o mesmo é colocado "em destaque"
   * sozinho no objeto de pedido, para alternar entre pedidos é necessário
   * remove-lo para colocar outro em destaque.
   */
  removeCurrentOrder({ commit, state }) {
    commit('REMOVE_ORDER_OBJECT')
  }
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/order.js